import { render, staticRenderFns } from "./associate-batch-modal.vue?vue&type=template&id=f5f27c2c&scoped=true&"
import script from "./associate-batch-modal.vue?vue&type=script&lang=js&"
export * from "./associate-batch-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f27c2c",
  null
  
)

export default component.exports